var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.24 2H11.346C9.582 2 8.184 2 7.091 2.148C5.965 2.3 5.054 2.62 4.336 3.341C3.617 4.062 3.298 4.977 3.147 6.107C3 7.205 3 8.608 3 10.379V16.217C3 17.725 3.92 19.017 5.227 19.559C5.16 18.649 5.16 17.374 5.16 16.312V11.302C5.16 10.021 5.16 8.916 5.278 8.032C5.405 7.084 5.691 6.176 6.425 5.439C7.159 4.702 8.064 4.415 9.008 4.287C9.888 4.169 10.988 4.169 12.265 4.169H15.335C16.611 4.169 17.709 4.169 18.59 4.287C18.3261 3.61329 17.8653 3.03474 17.2678 2.62678C16.6702 2.21883 15.9635 2.00041 15.24 2Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59961 11.3963C6.59961 8.67028 6.59961 7.30728 7.44361 6.46028C8.28661 5.61328 9.64361 5.61328 12.3596 5.61328H15.2396C17.9546 5.61328 19.3126 5.61328 20.1566 6.46028C21.0006 7.30728 20.9996 8.67028 20.9996 11.3963V16.2163C20.9996 18.9423 20.9996 20.3053 20.1566 21.1523C19.3126 21.9993 17.9546 21.9993 15.2396 21.9993H12.3596C9.64461 21.9993 8.28661 21.9993 7.44361 21.1523C6.59961 20.3053 6.59961 18.9423 6.59961 16.2163V11.3963Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0a163df2b2f2a5720e3bb9a4a4047eb7.svg";
export { ForwardRef as ReactComponent };